import z from 'zod';

export const moduleTopicSchema = z.object({
  topic: z.string(),
  category: z.string(),
  detail: z.string().optional(),
});

export interface ModuleTopic extends z.infer<typeof moduleTopicSchema> {}
